module.exports = __webpack_public_path__ + "img/avatar2.519f7598.webp";